import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { createRoot } from 'react-dom/client';
import * as React from 'react';
import { SiteService } from '@core/services/site.service';
import { Site } from '@core/interfaces/api';
import { Subscription } from 'rxjs';
import { ReactProvider } from '@shared/react-components/react-provider';
import { NotificationsPage } from '@features/notifications/notifications.page';

@Component({
  selector: 'app-notifications-react',
  template: '<div class="h-full w-full" #reactRoot></div>',
})
export class NotificationsReactWrapperComponent implements OnInit, OnDestroy {
  @ViewChild('reactRoot', { static: true }) containerRef!: ElementRef;

  private root: any;
  private currentSite: Site | null = null;
  private siteSubscription: Subscription;

  constructor(private siteService: SiteService) {}

  ngOnInit() {
    this.root = createRoot(this.containerRef.nativeElement);
    this.siteSubscription = this.siteService.site.subscribe((site) => {
      this.currentSite = site;
      this.render();
    });
  }

  ngOnDestroy() {
    if (this.root) {
      this.root.unmount();
    }
    if (this.siteSubscription) {
      this.siteSubscription.unsubscribe();
    }
  }

  private render() {
    this.root.render(
      React.createElement(
        ReactProvider,
        null,
        React.createElement(NotificationsPage, {
          siteId: this.currentSite?.id,
          timezone: this.currentSite?.timezone,
        }),
      ),
    );
  }
}

